<script>
	const Vue = require('vue');
	const Store = require('../kvstore');
	const Util = require('../utilities');
	const _ = require('underscore');
	const $ = require('jquery');
	const stringUtilities = require('utilities/stringUtilities');
	const metadata = require('core/metadata');
	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');
	const logger = require('utilities/logger');

	module.exports = {
		props: {
			// Some users have spaces in their passwords
			// This property allows us to ask them to change their
			// password during login if we notice their password has spaces
			'login-password': {
				type: String,
				required: false,
				default: ''
			},
			'checkbox-values': {
				required: false,
				default: () => []
			},
			'on-change': {
				required: false,
				default: $.noop
			},
			'part-of-row': {
				type: Boolean,
				default: false
			},
			'all-valid': {
				default: true
			},
			novalidate: {
				default: false,
				type: Boolean
			},
			rowClass: {
				type: String,
				default: ''
			},
			id: {
				type: String,
				required: false
			},
			required: {
				type: Boolean,
				required: false,
				default: false
			},
			data: {
				type: null // any
			},
			type: {
				required: true,
				type: String
			},
			placeholder: {
				required: false,
				type: String
			},
			'no-server-validation-messages': {
				type: Boolean,
				default: false
			},
			label: {
				type: String,
				required: false
			},
			labelclass: {
				type: String,
				required: false
			},
			name: {
				type: String,
				required: false
			},
			'include-other': {
				type: Boolean,
				required: false
			},
			isreadonly: {
				type: Boolean,
				default: false,
				required: false
			},
			'visible-password': {
				type: Boolean,
				default: false
			},
			// When error events are reported as coming from the server, this name is used
			// to identify whether the field represented by this auto-form-row corresponds
			// to the error from the server. e.g. an auto-form-row showing email doesn't "care"
			// about errors with the firstName field, so it only shows server errors for "email".
			// This property is here because sometimes the "type" of the auto-form-row doesn't
			// make the field name obvious. e.g. there could be 2 or more password fields on a
			// form
			'form-property': {
				type: String,
				required: false
			},

			// This is only used for type="select", you must pass a list of JS objects
			// with a text property to use as the label and a value property to use for the value
			options: {
				type: null,
				required: false
			},
			'min-length': {
				required: false
			},
			'max-length': {
				required: false,
				default: function () {
					if (this.type === 'firstName' || this.type === 'lastName' || this.type === 'studentUsername' || this.type === 'className') {
						return 64;
					} else if (this.type === 'password' || this.type === 'confirmedPassword') {
						return 32;
					} else if (this.type === 'classCode') {
						return 12;
					} else {
						return 2048;
					}
				}
			},
			'blank-value': {
				required: false
			},
			// This is used by type=select rows for high latency situations where loading options may take a while
			'options-loading': {
				type: Boolean,
				default: false,
				required: false
			},
			isdisabled: {
				type: Boolean,
				default: false,
				required: false
			},
			unsafe: {
				type: Boolean
			}
		},
		data: function () {
			return {
				dataOther: null,
				uniqueId: '',
				elementId: '',

				// normally, we don't show errors until the user has interacted with the
				// <auto-form-row>. We normally set this to true on focus. There is also a
				// case where we want to allow the user to try to submit and then show all
				// errors. In this case form-submitter will send a message to us that showErrorsYet
				// should be true now.
				showErrorsYet: false,

				focused: false,
				roles: [],
				classes: {},
				errors: {
					not: {},
					server: '',
					custom: ''
				},
				valid: true,
				formName: '',
				schoolOptions: [],

				// used only by type=submit and type=submitWithSurround
				submitInProgress: false,

				// map data prop to internal, mutable value
				dataInternal: '',

				// this second binding field is used only for confirmedPassword types,
				// it gives us a second value to compare
				data2: '',
				placeholder1: '',
				// a second placeholder field for confirmedPassword
				placeholder2: '',
				// a second id field for confirmedPassword
				id2: '',

				// map options to choices
				choices: undefined
			};
		},
		created() {
			this.elementId = this.id || 'form-input-comp-' + Store.inc('formInputComponentId');
			this.placeholder1 = this.placeholder;

			var self = this;
			if (self.type === 'confirmedPassword' || self.type === 'confirmedEmail') {
				self.watchValidityOf = 'data2';
				self.id2 = 'form-input-comp-' + Store.inc('formInputComponentId');
				if (/\|/.test(self.placeholder)) {
					var placeholderParts = self.placeholder.split(/\|/);
					self.placeholder1 = placeholderParts.shift();
					self.placeholder2 = placeholderParts.join('|');
				}
			}

			switch (self.type) {
				case 'role':
					self.roles = Util.sortObjects(metadata.roles, 'order');
					break;
				case 'grade':
					self.choices = metadata.gradesById;
					break;
				case 'grades':
					self.choices = metadata.gradeSelections;
					break;
			}

			if (self.type === 'checkboxes' || self.type === 'grades') {
				self.$watch(
					'checkboxValues',
					function (v, oldV) {
						var vals = _.clone(v);

						if (vals && vals.length) {
							var choices = Object.keys(self.choices);

							for (var i = 0, l = vals.length; i < l; i++) {
								var vv = vals[i],
									found = false;

								for (var j = 0, k = choices.length; j < k; j++) {
									if (choices[j] === vv) {
										found = true;

										break;
									}
								}

								if (!found) {
									self.dataOther = vv;

									break;
								}
							}
						}

						if (vals && vals.length) {
							this.$emit('update:data', vals.join());
						}
					},
					{
						immediate: true
					}
				);
			} else if (self.type === 'select') {
				self.$watch(
					'choices',
					function (value) {
						if (self.placeholder && !self.data) {
							this.$emit('update:data', '__BLANK__');
						}
					},
					{
						immediate: true
					}
				);
			}

			if (self.type === 'radiobuttons') {
				self.$watch(
					'radiobuttonValue',
					function (v, oldV) {
						self.$emit('update:data', self.radiobuttonValue);
					},
					{
						immediate: true
					}
				);
			}

			if (self.type === 'radiobuttons') {
				self.$watch(
					'radiobuttonOther',
					function (v, oldV) {
						if (self.radiobuttonOther) {
							this.$emit('update:data', self.radiobuttonOther);
						}
					},
					{
						immediate: true
					}
				);
			}

			if (self.includeOther) {
				self.$watch(
					'dataOther',
					function (v, oldV) {
						if (self.checkboxValues) {
							var oldIndex = self.checkboxValues.indexOf(oldV);

							if (oldIndex !== -1) {
								self.checkboxValues.splice(oldIndex, 1);
							}

							if (v && v.trim() !== '') {
								self.checkboxValues.push(v);
							}
						}
					},
					{
						immediate: false
					}
				);
			}
		},
		watch: {
			data: {
				handler(value) {
					this.clearServerErrors();
					this.errors.custom = '';
					this.dataInternal = value !== undefined ? value : '';
				},
				immediate: true,
				deep: true
			},
			dataInternal(value) {
				this.checkAllValidators(value);
				if (value !== this.data) {
					this.$emit('update:data', value);
				}
			},
			data2(value) {
				this.checkAllValidators(value);
			},
			errors: {
				handler(e) {
					this.updateValid();
				},
				deep: true
			},
			options: {
				handler(options) {
					this.choices = options;
				},
				immediate: true
			}
		},
		mounted() {
			var self = this;

			self.uniqueId = Store.inc('autoFormRowUniqueId');

			this.rowClass = this.rowClass.trim();
			if (this.rowClass) {
				for (const c of this.rowClass.split(/\s+/)) {
					this.classes[Util.camelCase(c)] = true;
				}
			}

			// once we're notified of a form name, then send a message to the parent that this
			// component exists. This way, the form-submitter can track whether all the auto-form-row
			// components are valid

			Vue.nextTick(() => {
				self.formName = $(self.$el).parents('form').attr('name');
				if (self.formName) {
					pubsub.publish('auto-form-row-ready-' + self.formName, self.uniqueId);

					self.$watch(
						'valid',
						function (v) {
							pubsub.publish('auto-form-row-validity-' + self.formName, self.uniqueId, v);
						},
						{
							immediate: true
						}
					);
				}

				this.checkAllValidators(this[this.fieldValueKey]);
			});

			pubsub.subscribe('form-reset', function () {
				self.reset();
				return true;
			});

			pubsub.subscribe('submit-failed', function (evData) {
				if (evData.formName !== self.formName) {
					return true;
				}

				self.showErrorsYet = true;

				var response = evData.res && evData.res.body;

				if (response) {
					// if there are multiple selections for a property, the name may end in -0 or -1
					// but the server usually does not know about a key with this name. So we check for the
					// form property first, then we check for it without the trailing -<digit>
					// This allows us to have custom error messages (e.g. "show a message over questionSet-3")
					// for specific choices with custom validators, but still show server error messages for
					// "questionSet" (no -3 or -2 or whatever)
					var formProperty = self.formPropertyInternal;
					var numberlessKey = formProperty.replace(/-\d+$/, '');

					var errorsForThisProperty = evData.res.body[formProperty] || evData.res.body[numberlessKey];

					if (errorsForThisProperty && !this.noServerValidationMessages) {
						// Are these errors mutually exclusive?
						if (errorsForThisProperty.invalid) {
							self.errors.server = stringUtilities.capitalize(formProperty) + ' invalid.';
						} else if (errorsForThisProperty.required) {
							self.errors.server = stringUtilities.capitalize(formProperty) + ' required.';
						} else if (errorsForThisProperty.notAllowed) {
							self.errors.server = stringUtilities.capitalize(formProperty) + ' not allowed.';
						} else {
							self.errors.server = errorsForThisProperty.custom;
						}
					}
				}

				return true;
			});

			self.$on('custom-error', function (evData) {
				if (evData.name === self.formPropertyInternal) {
					self.errors.custom = evData.message;
				}
				return true;
			});

			pubsub.subscribe('submit-succeeded', function () {
				if (self.type === 'confirmedPassword' || self.type === 'confirmedEmail') {
					self.data2 = '';
				}

				self.reset();
				return true;
			});

			if (self.type === 'submit' || self.type === 'submitWithSurround') {
				pubsub.subscribe('before-submit', function (ev) {
					if (ev.formName === self.formName) {
						self.submitInProgress = true;
					}
					return true;
				});
				pubsub.subscribe('submit-succeeded', function (ev) {
					if (ev.formName === self.formName) {
						self.submitInProgress = false;
					}
					return true;
				});
				pubsub.subscribe('submit-failed', function (ev) {
					if (ev.formName === self.formName) {
						self.submitInProgress = false;
					}
					return true;
				});
			}
		},
		beforeDestroy: function () {
			if (this.formName) {
				pubsub.publish('auto-form-row-destroy-' + this.formName, this.uniqueId);
			}
		},
		validators: {
			zipcode: function (val) {
				return !val || Util.regexp.zipcode.test(val);
			},
			sameasdata1: function (val, unused, vm) {
				return val === vm.data;
			},
			sameasdata1caseinsensitive: function (val, unused, vm) {
				return (val || '').toLowerCase() === (vm.data || '').toLowerCase();
			},
			nonemail: function (val) {
				return !val || !/@/.test(val);
			},
			nospaces: function (val) {
				return !val || !/\s/.test(val);
			},
			email: function (val) {
				return !val || Util.regexp.email.test(val);
			},
			hasupper: function (val) {
				return !val || !!val.match(/[A-Z]/);
			},
			haslower: function (val) {
				return !val || !!val.match(/[a-z]/);
			},
			hasdigit: function (val) {
				return !val || !!val.match(/[0-9]/);
			},
			hasspecialchar: function (val) {
				return !val || !!val.match(Util.regexp.hasspecialchar);
			},
			minLength: function (val, l) {
				if (!l) {
					return true;
				}

				return !val || val.length >= l;
			},
			maxLength: function (val, l) {
				if (!l) {
					return true;
				}

				return !val || val.length <= l;
			},
			required: {
				alwaysOn: true,
				outputName: 'provided',
				validate: function (val, isRequired) {
					if (!isRequired) {
						return true;
					}

					let isValid = !!val;

					if (isValid && typeof val === 'string' && val.length) {
						isValid = val.trim && val.trim().length > 0;
					}
					return isValid;
				}
			},
			nolineover: function (val, l) {
				l = parseInt(l);
				var ok = true;
				if (!val) {
					return true;
				}

				_.each(val.split(/\n/), function (line) {
					if (line.length > l) {
						ok = false;
					}
				});
				return ok;
			},
			password(val, type) {
				return !type || Util.regexp[`${type}Password`]?.test(val);
			}
		},
		computed: {
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			},
			fieldValueKey() {
				const type = this.type;
				const defaultKey = 'dataInternal';

				const keyDict = {
					confirmedEmail: 'data2',
					confirmedPassword: 'data2',
					radio: 'radioButtonValue',
					checkboxes: 'checkboxValues'
				};

				return keyDict[type] || defaultKey;
			},
			fieldValidators() {
				const type = this.type;
				const required = this.required;
				const minLength = this.minLength;
				const maxLength = this.maxLength;
				const loginPassword = this.loginPassword;

				const validatorDict = {
					email: {
						email: true,
						required,
						maxLength,
						minLength
					},
					confirmedEmail: {
						required,
						sameasdata1caseinsensitive: true
					},
					password: {
						password: loginPassword,
						required: !loginPassword && required,
						minLength: loginPassword ? 0 : minLength || 4,
						nospaces: !loginPassword
					},
					confirmedPassword: {
						required,
						minLength: minLength || 4,
						maxLength,
						sameasdata1: true
					},
					firstName: {
						minLength: minLength || 1,
						maxLength,
						required
					},
					lastName: {
						minLength: minLength || 1,
						maxLength,
						required
					},
					className: {
						minLength: minLength || 2,
						maxLength,
						required
					},
					classCode: {
						minLength: 6,
						maxLength: 6,
						required
					},
					role: {
						required
					},
					text: {
						minLength,
						maxLength,
						required
					},
					zipcode: {
						zipcode: true
					},
					radiobuttons: {
						required
					},
					checkboxes: {
						required
					},
					grade: {
						required
					},
					textarea: {
						required,
						maxLength,
						minLength
					},
					studentUsername: {
						minLength: minLength || 2,
						maxLength,
						required,
						nonemail: true,
						nospaces: true
					},
					select: {
						required
					},
					roster: {
						required,
						nolineover: 64
					}
				};

				return validatorDict[type] || {};
			},
			formPropertyInternal() {
				if (typeof this.formProperty !== 'undefined') {
					return this.formProperty;
				}

				const propertyDict = {
					studentUsername: 'username',
					className: 'name'
				};

				return propertyDict[this.type] || this.type;
			}
		},
		methods: {
			reset: function () {
				var self = this;

				// other handlers may be clearing data, so wait 50ms before resetting flags
				// this way, we're showing not "required" errors on an empty form
				// FIXME: setTimeout is inelegant, is there a better way?
				setTimeout(function () {
					self.showErrorsYet = false;
					self.clearServerErrors();
				}, 50);
			},
			clearServerErrors: function () {
				this.errors.server = '';
			},
			focusInput: function () {
				this.focused = true;
			},
			blurInput: function () {
				this.focused = false;
				this.showErrorsYet = true;
			},
			canShowErrorsNow: function () {
				this.showErrorsYet = true;
			},
			updateValid: function () {
				var self = this;

				// data is valid if all the "not" properties and all the "server" are false
				var total = 0,
					valid = 0;

				_.each(self.errors.not, function (hadError) {
					total++;
					if (!hadError) {
						valid++;
					}
				});

				_.each(self.errors.server, function (hadError) {
					total++;
					if (!hadError) {
						valid++;
					}
				});

				// count the "custom" error
				total++;
				if (!self.errors.custom) {
					valid++;
				}

				self.valid = valid === total;
			},
			formatValue(value, type) {
				const formatters = {
					lower(val) {
						return val ? val.toLowerCase() : val;
					},
					upper(val) {
						return val ? val.toUpperCase() : val;
					},
					trim(val) {
						return val ? val.trim() : val;
					}
				};

				const formatter = formatters[type];

				if (formatter) {
					return formatter(value);
				}
				return value;
			},
			checkValidity(value, validatorName, validatorValue) {
				let valid;

				// get the function or object that is our validator
				const validator = this.$options.validators[validatorName];
				if (!validator) {
					logger.info('failed to find validator', validatorName, this);
					return;
				}

				// what do we call it in the output data structure?
				// It looked wrong to show an error "if errors.not.required", so
				// this allows us to provide a "friendly" name so that we can say
				// "if errors.not.provided" in our template
				const name = validator.outputName || validatorName;

				// If we have set novalidate then only an alwaysOn validator will trigger
				// required is the only alwaysOn validator, so if required is specified with
				// novalidate, then the required validator still fires
				if (this.novalidate && !validator.alwaysOn) {
					valid = true;
				} else {
					// if the function/object has a validate property, then call
					// that to validate, otherwise the object itself must be a function
					const validatorFunc = validator.validate || validator;

					valid = validatorFunc(value, validatorValue, this);
				}

				Vue.set(this.errors, name, valid);
				Vue.set(this.errors.not, name, !valid);
			},
			checkAllValidators(value) {
				const validators = this.fieldValidators;

				for (const validator in validators) {
					this.checkValidity(value, validator, validators[validator]);
				}
			},
			onInput(value, formatters = []) {
				if (this.unsafe) {
					value = stringUtilities.stripHTML(value);
				}

				for (const formatter of formatters) {
					value = this.formatValue(value, formatter);
				}

				this[this.fieldValueKey] = value;
			},
			onChangeHandler(value) {
				this.onChange(value);
			},
			validateAndShowErrors(value) {
				this.canShowErrorsNow();
			}
		}
	};
</script>
<template>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-if="type === 'email'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Email' }}
			</label>
			<span
				class="required"
				v-if="required"
				>*</span
			>
			<input
				:value="dataInternal"
				@input="onInput($event.target.value, ['lower'])"
				@blur="blurInput"
				@focus="focusInput"
				:required="required"
				:placeholder="placeholder1"
				:readonly="isreadonly"
				:disabled="isdisabled"
				class="input"
				type="email"
				:id="elementId"
				:name="`${elementId}_email`"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.email">Invalid address</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li
					v-if="errors.server"
					v-html="errors.server"></li>
				<li v-if="errors.not.provided">This is required</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		v-else-if="type === 'confirmedEmail'">
		<auto-form-row
			:placeholder="placeholder1"
			type="email"
			:data.sync="dataInternal"
			:row-class="rowClass"
			:min-length="minLength"
			:max-length="maxLength"
			:required="required"
			:novalidate="novalidate"
			:form-name="formName">
		</auto-form-row>
		<div :class="{ 'form-row': !partOfRow }">
			<div class="form-row-input">
				<label
					:for="elementId"
					class="label"
					:class="{ 'hidden-visually': classes.labelHiddenVisually }">
					{{ label || 'Confirm Email' }}
				</label>
				<span
					class="required"
					v-if="required"
					>*</span
				>
				<input
					class="input"
					:name="`${elementId}_confirm_email`"
					type="email"
					:required="required"
					@blur="blurInput"
					@focus="focusInput"
					:id="elementId"
					:placeholder="placeholder2"
					:value="data2"
					@input="onInput($event.target.value, ['lower'])"
					:aria-invalid="!valid"
					:aria-describedby="`${elementId}_errors`" />
				<ul
					:id="`${elementId}_errors`"
					class="validation-error"
					:class="{ coaching: focused && !novalidate }"
					v-if="!valid && showErrorsYet">
					<li
						class="warning"
						v-if="errors.not.sameasdata1caseinsensitive">
						Email does not match.
					</li>
					<li v-if="errors.not.provided">This is required</li>
					<li v-if="errors.custom">{{ errors.custom }}</li>
				</ul>
				<ul
					:id="`${elementId}_errors`"
					class="validation-error"
					v-else-if="data2 && !errors.not.sameasdata1caseinsensitive">
					<li class="greenlight">Emails match.</li>
				</ul>
			</div>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'password'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Password' }}
			</label>
			<span
				class="required"
				v-if="required"
				>*</span
			>
			<input
				class="input"
				:name="`${elementId}_password`"
				@blur="blurInput"
				@focus="focusInput"
				:id="elementId"
				:type="visiblePassword ? 'text' : 'password'"
				:required="required"
				:placeholder="placeholder1"
				:maxlength="maxLength"
				:value="dataInternal"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`"
				@input="onInput($event.target.value)" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				:class="{ coaching: focused && !novalidate }"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.not.password">
					<template v-if="loginPassword === 'student'"> Passwords must be a minimum of 8 characters and must not include spaces.</template>
					<template v-else>
						Passwords must be a minimum of 8 characters, and include both upper and lower case or a number or special character.
					</template>
				</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.provided">This is required</li>
				<li v-if="errors.not.nospaces">
					<template v-if="loginPassword === 'student'">
						Spaces are not allowed, if your current password contains spaces please have your teacher reset it
					</template>
					<template v-if="loginPassword === 'teacher'">
						Spaces are not allowed, if your current password contains spaces please use the "Forgot password?" link to set a new password
					</template>
					<template v-if="loginPassword !== 'student' && loginPassword !== 'teacher'"> Spaces are not allowed </template>
				</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		v-else-if="type === 'confirmedPassword'">
		<auto-form-row
			:placeholder="placeholder1"
			type="password"
			:data.sync="dataInternal"
			:row-class="rowClass"
			:min-length="minLength"
			:max-length="maxLength"
			:required="required"
			:login-password="loginPassword"
			:form-name="formName">
		</auto-form-row>
		<div :class="{ 'form-row': !partOfRow }">
			<div class="form-row-input">
				<label
					:for="id2"
					class="label"
					:class="{ 'hidden-visually': classes.labelHiddenVisually }">
					{{ label || 'Confirm Password' }}
				</label>
				<span
					class="required"
					v-if="required"
					>*</span
				>
				<input
					class="input"
					:name="`${elementId}_confirm_password`"
					type="password"
					:required="required"
					:value="data2"
					@input="onInput($event.target.value)"
					@blur="blurInput"
					@focus="focusInput"
					:id="id2"
					:placeholder="placeholder2"
					:maxlength="maxLength"
					:aria-invalid="!valid"
					:aria-describedby="`${id2}_errors`" />
				<ul
					:id="`${id2}_errors`"
					class="validation-error"
					:class="{ coaching: focused && !novalidate }"
					v-if="!valid && showErrorsYet">
					<li v-if="errors.not.minLength">Too short</li>
					<li v-if="errors.not.provided">This is required</li>
					<li
						class="warning"
						v-if="errors.not.sameasdata1">
						Password does not match.
					</li>
				</ul>
				<ul
					:id="`${id2}_errors`"
					class="validation-error"
					v-else-if="data2 && !errors.not.sameasdata1">
					<li class="greenlight">Passwords match.</li>
				</ul>
			</div>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'firstName'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'First Name' }}
			</label>
			<span
				class="required"
				v-if="required"
				>*</span
			>
			<input
				class="input"
				type="text"
				:placeholder="placeholder1"
				:required="required"
				:id="elementId"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:maxlength="maxLength"
				:value="dataInternal"
				@input="onInput($event.target.value)"
				@blur="blurInput"
				@focus="focusInput"
				:name="`${elementId}_firstname`"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.provided">You must provide a first name</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'lastName'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Last Name' }}
			</label>
			<span
				class="required"
				v-if="required"
				>*</span
			>
			<input
				class="input"
				type="text"
				:placeholder="placeholder1"
				:required="required"
				:id="elementId"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:maxlength="maxLength"
				:name="`${elementId}_lastname`"
				:value="dataInternal"
				@input="onInput($event.target.value)"
				@blur="blurInput"
				@focus="focusInput"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.provided">You must provide a last name</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		class="form-row"
		v-else-if="type === 'className'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Class Name' }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</label>
			<input
				class="input"
				type="text"
				:placeholder="placeholder1"
				:required="required"
				:id="elementId"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:maxlength="maxLength"
				:name="`${elementId}_classname`"
				:value="dataInternal"
				@input="onInput($event.target.value)"
				@blur="blurInput"
				@focus="focusInput"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.provided">You must provide a class name</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'classCode'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Class Code' }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</label>
			<input
				class="input"
				type="text"
				:placeholder="placeholder1"
				:required="required"
				:id="elementId"
				:readonly="isreadonly"
				:disabled="isdisabled"
				maxlength="6"
				:value="dataInternal"
				@input="onInput($event.target.value, ['trim', 'upper'])"
				@blur="blurInput"
				@focus="focusInput"
				:name="`${elementId}_classCode`"
				required
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.provided">You must provide a Class Code</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'role'">
		<div class="form-row-input">
			<label
				:for="elementId"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Role' }}
				<span
					class="required"
					v-if="required"
					style="margin-top: 1em"
					>*</span
				>
			</label>
			<div class="input-select">
				<select
					v-model="dataInternal"
					:name="`${elementId}_role`"
					@change="validateAndShowErrors(dataInternal)"
					:id="elementId"
					:required="required"
					:readonly="isreadonly"
					:disabled="isdisabled"
					:aria-invalid="!valid"
					:aria-describedby="`${elementId}_errors`">
					<option
						disabled
						selected
						value="">
						{{ placeholder || 'Please choose a Role' }}
					</option>
					<option
						v-for="r in roles"
						:key="r.value"
						:value="r.value">
						{{ r.text }}
					</option>
				</select>
				<ul
					:id="`${elementId}_errors`"
					class="validation-error"
					v-if="!valid && showErrorsYet">
					<li v-if="errors.not.provided">You must select a role</li>
					<li v-if="errors.server">{{ errors.server }}</li>
					<li v-if="errors.custom">{{ errors.custom }}</li>
				</ul>
			</div>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'checkbox'">
		<div class="form-row-input">
			<label>
				<input
					class="input-checkbox"
					type="checkbox"
					:id="elementId"
					@change="canShowErrorsNow"
					:required="required"
					:readonly="isreadonly"
					:disabled="isdisabled"
					v-model="dataInternal"
					:aria-invalid="!valid"
					:aria-describedby="`${elementId}_errors`" />
				<span :class="labelclass">{{ label }}</span>
			</label>
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'text'">
		<div class="form-row-input">
			<label
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</label>
			<input
				class="input"
				type="text"
				:name="`${elementId}_text`"
				@blur="blurInput"
				@focus="focusInput"
				:id="elementId"
				:required="required"
				:placeholder="placeholder1"
				:value="dataInternal"
				@input="onInput($event.target.value)"
				:maxlength="maxLength"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.provided">This is required</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'zipcode'">
		<div class="form-row-input">
			<label
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</label>
			<input
				v-model="dataInternal"
				class="input"
				type="text"
				:name="`${elementId}_zip`"
				@blur="blurInput"
				@focus="focusInput"
				:id="elementId"
				:required="required"
				:placeholder="placeholder1"
				:readonly="isreadonly"
				:disabled="isdisabled"
				@input="checkValidity(dataInternal, zipcode, true)"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
				<li v-if="dataInternal && errors.not.zipcode">Invalid zipcode.</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'grades'">
		<div class="form-row-input">
			<span
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Select Grade Levels You Teach' }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</span>
			<input
				type="hidden"
				v-model="dataInternal" />
			<div class="input-checkbox-grid">
				<span
					v-for="grade in choices"
					:key="grade.id"
					class="input-checkbox-grid-item">
					<input
						number
						type="checkbox"
						@change="canShowErrorsNow"
						:name="`${elementId}_gradeLevel`"
						:value="grade.id"
						:id="`input-gradelevel-${grade.id}`"
						v-model="checkboxValues" />
					<label :for="`input-gradelevel-${grade.id}`">{{ grade.text }}</label>
				</span>
			</div>
			<ul
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'radiobuttons'">
		<div class="form-row-input">
			<span
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</span>
			<label
				v-for="(choice, id) in choices"
				:key="choice.id">
				<input
					:required="required"
					v-model="radiobuttonValue"
					@change="validateAndShowErrors(radiobuttonValue)"
					type="radio"
					:value="choice.id || choice.value || id" />
				{{ choice[labelField || 'text'] }}
			</label>
			<input
				v-if="includeOther"
				:disabled="radiobuttonValue !== 393"
				:required="required"
				@change="validateAndShowErrors(radiobuttonOther)"
				@blur="blurInput"
				@focus="focusInput"
				v-model="radiobuttonOther"
				class="input"
				type="text" />
			<ul
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'checkboxes'">
		<div class="form-row-input">
			<span
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label }}
				<span
					class="required"
					v-if="required"
					>*</span
				>
			</span>
			<label
				v-for="(choice, id) in choices"
				:key="choice.id">
				<input
					:required="required"
					:name="`${elementId}_checkbox`"
					v-model="checkboxValues"
					type="checkbox"
					@change="validateAndShowErrors(checkboxValues)"
					:value="elementId" />{{ choice[labelField || 'text'] }}
			</label>
			<template v-if="includeOther">
				<label :for="`${elementId}-other`">Other:</label>
				<input
					:id="`${elementId}-other`"
					:required="required"
					:value="dataOther"
					@input="onInput($event.target.value, 'dataOther', [], { required, maxLength })"
					@blur="blurInput"
					@focus="focusInput"
					:maxlength="maxLength"
					class="input"
					type="text" />
			</template>
			<ul
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
				<li v-if="errors.not.maxLength">Too long</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'grade'">
		<div class="form-row-input">
			<span
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Select Grade Of This Class' }}
			</span>
			<span
				class="required"
				v-if="required"
				>*</span
			>
			<div
				class="input-select"
				style="width: 7rem">
				<select
					v-model="dataInternal"
					name="grade"
					:id="elementId"
					:required="required"
					:placeholder="placeholder1"
					:readonly="isreadonly"
					:disabled="isdisabled"
					:aria-invalid="!valid"
					:aria-describedby="`${elementId}_errors`">
					<option
						disabled
						value="">
						Grade
					</option>
					<option
						v-for="(grade, id) in choices"
						:key="grade.id"
						:value="grade.id">
						{{ grade.text }}
					</option>
				</select>
			</div>
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow, 'submit-button': true }"
		v-else-if="type === 'submit'">
		<div class="form-row-input">
			<button
				type="submit"
				class="button -large"
				:class="{
					'-disabled': !allValid || submitInProgress,
					'-full-width': classes.dashFullWidth,
					'-wide': classes.dashWide,
					'-centered': classes.dashCentered
				}"
				:disabled="!allValid || submitInProgress">
				<slot></slot>
			</button>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'textarea'">
		<div class="form-row-input">
			<textarea
				v-model="dataInternal"
				:class="['input', rowClass]"
				:name="`${elementId}_role`"
				:id="elementId"
				:required="required"
				@change="onChangeHandler(dataInternal)"
				:maxlength="maxLength"
				:placeholder="placeholder1"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`">
			</textarea>
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.not.minLength">Too short</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'submitWithSurround'">
		<div class="form-row-input">
			<slot name="pre-submit"></slot>
			<button
				type="submit"
				:class="[rowClass || 'button -large -full-width', { '-disabled': !allValid || submitInProgress || isdisabled }]"
				:disabled="!allValid || submitInProgress || isdisabled">
				{{ label || 'Submit' }}
			</button>
			<slot name="post-submit"></slot>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'studentUsername'">
		<div class="form-row-input">
			<label
				:for="elementId"
				class="label"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				{{ label || 'Username' }}
			</label>
			<input
				style="text-transform: lowercase"
				class="input"
				type="text"
				:placeholder="placeholder1"
				:required="required"
				:id="elementId"
				:readonly="isreadonly"
				:disabled="isdisabled"
				:name="`${elementId}_studentUsername`"
				:maxlength="maxLength"
				:value="dataInternal"
				@input="onInput($event.target.value, ['lower'])"
				@blur="blurInput"
				@focus="focusInput"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`" />
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="showErrorsYet && !valid">
				<li v-if="errors.not.provided">You must provide a username</li>
				<li v-if="errors.not.minLength">Too short</li>
				<li v-if="errors.not.maxLength">Too long</li>
				<li v-if="errors.not.nonemail">You cannot use your email address</li>
				<li v-if="errors.not.nospaces">You cannot use spaces</li>
				<li v-if="errors.server">{{ errors.server }}</li>
				<li v-if="errors.custom">{{ errors.custom }}</li>
			</ul>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'select'">
		<div class="form-row-input">
			<label
				:for="elementId"
				:class="{ 'hidden-visually': classes.labelHiddenVisually }">
				<span v-html="label"></span>
				<img
					:src="loaderImageSrc"
					v-if="optionsLoading"
					alt="Loading" />
			</label>
			<div class="input-select">
				<select
					v-model="dataInternal"
					:name="`${elementId}_select`"
					:id="elementId"
					:required="required"
					:readonly="isreadonly"
					:disabled="isdisabled"
					:aria-invalid="!valid"
					:aria-describedby="`${elementId}_errors`">
					<option
						v-if="placeholder"
						value="__BLANK__"
						disabled>
						{{ placeholder }}
					</option>
					<option
						v-for="c in choices"
						:key="c.value"
						:disabled="c.disabled"
						:value="c.value">
						{{ c.text }}
					</option>
				</select>
				<ul
					:id="`${elementId}_errors`"
					class="validation-error"
					v-if="!valid && showErrorsYet">
					<li v-if="errors.not.provided">You must select an option for {{ label }}</li>
					<li v-if="errors.server">{{ errors.server }}</li>
					<li v-if="errors.custom">{{ errors.custom }}</li>
				</ul>
			</div>
		</div>
	</div>
	<div
		:data-auto-form-row-id="uniqueId"
		:class="{ 'form-row': !partOfRow }"
		v-else-if="type === 'roster'">
		<div
			class="form-row-input"
			v-safe-textarea-placeholder="placeholder">
			<textarea
				:value="dataInternal"
				:class="['input', rowClass]"
				:name="`${elementId}_roster`"
				style="width: 100%; height: 18rem"
				@blur="blurInput"
				@focus="focusInput"
				:id="elementId"
				:required="required"
				:readonly="isreadonly"
				:disabled="isdisabled"
				@input="onInput($event.target.value)"
				:aria-invalid="!valid"
				:aria-describedby="`${elementId}_errors`"></textarea>
			<ul
				:id="`${elementId}_errors`"
				class="validation-error"
				v-if="!valid && showErrorsYet">
				<li v-if="errors.not.provided">Please enter student names, 1 student per line</li>
				<li v-if="errors.not.nolineover">No student name can be over 64 characters</li>
			</ul>
		</div>
	</div>
</template>
